import React from 'react'
import PropTypes from 'prop-types'
import {Heading} from '@salesforce/retail-react-app/app/components/shared/ui'

const Title = ({title, color, tag, titleFontFamily, fontSize}) => {
    return (
        <Heading
            as={tag}
            margin="0"
            fontSize={fontSize}
            letterSpacing={{base: '0.18px', xs: '0.21px'}}
            fontFamily={titleFontFamily || 'caslon'}
            fontWeight="500"
            lineHeight="normal"
            textAlign="center"
            color={color}
            whiteSpace="break-spaces"
        >
            {title}
        </Heading>
    )
}

Title.propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    tag: PropTypes.string,
    titleFontFamily: PropTypes.string,
    fontSize: PropTypes.object
}

export default Title
